"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = exports.COLORS = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const color_1 = __importDefault(require("@app/util/color"));
var COLORS;
(function (COLORS) {
    COLORS["DEFAULT"] = "DEFAULT";
    COLORS["PRIMARY"] = "PRIMARY";
    COLORS["BRIGHT"] = "BRIGHT";
    COLORS["DANGER"] = "DANGER";
    COLORS["WARNING"] = "WARNING";
    COLORS["SUCCESS"] = "SUCCESS";
    COLORS["WHITE"] = "WHITE";
    COLORS["GRAY"] = "GRAY";
    COLORS["DARK_BLUE"] = "DARK_BLUE";
})(COLORS || (exports.COLORS = COLORS = {}));
const Color = ({ children, color, src, }) => {
    let style;
    // try using 'src' prop to generate the color if 'color' prop is not set
    if (!color && src) {
        const { color: srcColor, id, value } = src;
        color = srcColor || color_1.default.idToColor(id, null) || color_1.default.idToColor(value, null);
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        style = { backgroundColor: '#' + color };
    }
    const className = color ? `ds-color ${color.toLowerCase()}` : 'ds-color';
    return react_1.default.createElement("div", { className: className, style: style }, children);
};
exports.Color = Color;
Color.COLORS = COLORS;
